import { render, staticRenderFns } from "./invoice-record.vue?vue&type=template&id=bab9dce0&scoped=true"
import script from "./invoice-record.vue?vue&type=script&lang=js"
export * from "./invoice-record.vue?vue&type=script&lang=js"
import style0 from "./invoice-record.vue?vue&type=style&index=0&id=bab9dce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab9dce0",
  null
  
)

export default component.exports